import {createApp} from 'vue';
import App from '@/App.vue';
import router from '@/router.js';

import 'default-passive-events';
import 'element-plus/dist/index.css';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'dayjs/locale/zh-cn.js';
import axios from 'axios';
import VueAxios from 'vue-axios';

// import piniaPluginPersisted from 'vue3-persist-storages';
import {createPinia} from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import utils from './assets/js/utils.js';
import intervals from './assets/js/intervals.js';
import Modal from './assets/js/dzmodal.js';
import AuthPlugin from './plugins/auth.js';

// import mqtt from './assets/js/mqtt.js';
// import VueMqtt from 'vue-mqtt';
// Vue.use(VueMqtt, 'ws://iot.eclipse.org/ws', options);

axios.defaults.withCredentials = true;
// 在开发环境中不设置baseURL，让代理正常工作
// 在生产环境中设置baseURL
axios.defaults.baseURL = process.env?.VUE_APP_API_URL;

const app = createApp(App)
    .use(router)
    .use(createPinia().use(piniaPluginPersistedstate))
    .use(utils)
    .use(intervals)
    .use(ElementPlus, {locale: zhCn})
    .use(VueAxios, axios)
    .use(AuthPlugin)
    .use(Modal);
// .use(mqtt)

app.mount('#app');
